import React from 'react';
import { Box, Typography, Button, Icon } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import SectionCard from '../../components/SectionCard';

import useStyles from './styles';

const NoMatch = () => {
  const classes = useStyles();

  return (
    <SectionCard className={classes.container}>
      <Helmet>
        <title>Página não encontrada.</title>
      </Helmet>
      <Box className="not-found-content">
        <Icon className="not-found-icon">warning</Icon>
        <Typography className="not-found-title" variant="h4">
          Página não encontrada.
        </Typography>
        <Typography className="not-found-description" variant="body1">
          O conteúdo que você está tentando acessar não existe ou não está mais
          disponível para visualização.
        </Typography>
        <Button
          className="not-found-button"
          variant="contained"
          color="primary"
          startIcon={<Icon>keyboard_backspace</Icon>}
          component={Link}
          to="/"
        >
          Voltar para o início
        </Button>
      </Box>
    </SectionCard>
  );
};

export default NoMatch;
